<template>
<div class="drag-selector-item-wrapper"
    @mousedown.stop
    @click.stop="handleClick">
  <component
    :is="componentName"
    :class="[selected ? 'selected' : '']"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </component>
  </div>
</template>
<script>
/* Components which can be used as drag selector item */
import ExerciseTile from "@/components/exercises/ExerciseTile.vue"
import emitter from '@/mixins/emitter'
export default {
  name: 'DragSelectorItem',
  mixins: [emitter],
  components: {ExerciseTile},
  props: {
    componentName: {
      type: String,
      required: true,
      default: 'div'
    },
    dragSelectorElement: {
      default: true,
    },
    rememberSelection: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    disabledClick: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selected: false,
    }
  },
  mounted() {
    this.dispatch('DragSelector', 'on-drag-selector-item-add', this)

    if (this.isSelected && this.rememberSelection) {
      this.selected = true
    }
  },
  destroyed() {
    if (!this.rememberSelection) {
      this.dispatch('DragSelector', 'drag-selector-item-change', {
        selected: false,
        value: this.dragSelectorElement,
      })
    }
    this.dispatch('DragSelector', 'on-drag-selector-item-remove', this)
  },
  methods: {
    handleClick() {
      if (!this.disabledClick) {
        this.handleSelectChange(!this.selected)
      }
    },
    changeSelect(val) {
      this.handleSelectChange(val === true)
    },
    handleSelectChange(val) {
      if (this.selected === val) return

      this.selected = val
      this.dispatch('DragSelector', 'drag-selector-item-change', {
        selected: this.selected,
        value: this.dragSelectorElement,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.drag-selector-item-wrapper {
  cursor: move;
}
.selected {
  &::after {
    position: 'absolute';
    top: 0;
    left: 0;
    width: 100px;
    height: 100px;
    background: #000;
    z-index: 9999;
  }
}
</style>
